<template lang="pug">
  v-navigation-drawer#app-drawer(:mini-variant='mini', v-model='inputValue', app='', dark='', floating='', persistent='', permanent='', mobile-break-point='991', width='260' style='background:black')
    v-list
      v-list-tile(@click.stop='mini = !mini')
        v-list-tile-action
          v-icon menu
        v-list-tile-title {{ nombre }} {{ apellido }}
      v-list-tile(avatar='', tag='div')
        div(style='margin-left:75px')
          //- img(v-if='mini === false',src='../assets/logo.png', width='100' ,height='40')
        div(style='margin-left:-45px')
          //- img(v-if='mini === true',src='../assets/logomini.png', with='40' ,height='40', style='margin-left:15px;')
    v-layout.fill-height(tag='v-list', column='')
      v-divider
      v-list-tile.v-list-item(v-for='(link, i) in items2', :key='i', active-class='secundary', :to='link.link', avatar='')
        v-list-tile-action
          v-icon.mgl {{ link.icon }}
        v-list-tile-title(v-text='link.title')
      v-list-tile.v-list-item(active-class='secundary', @click='logout' ,avatar='')
        v-list-tile-action
          v-icon.mgl lock_open
        v-list-tile-title Cerrar de sesión
</template>

<script>
import Api from "@/services/methods";
import { server, port } from "@/services/environment";
export default {
  name: "mHeader",
  data: () => ({
    ruta: server + ":" + port,
    settings: {},
    chf: false,
    nombre: "",
    apellido: "",
    drawer: true,
    inputValue: true,
    mini: true,
    image:
      "https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg",
    items2: [
      {
        icon: "analytics",
        title: "Dashboard",
        link: "/dashboard",
        requiresAuth: true
      },
      {
        icon: "mail",
        title: "SMS",
        link: "/sms",
        requiresAuth: true
      },
      {
        icon: "mail",
        title: "Enviados",
        link: "/enviados",
        requiresAuth: true
      },
      {
        icon: "mail",
        title: "No enviados",
        link: "/noenviados",
        requiresAuth: true
      }
    ]
  }),
  created() {
    this.initialize();
    if (this.$store.state.mensajitoEmpUser) {
      this.nombre = this.$store.state.mensajitoEmpUser.nombre;
      this.apellido = this.$store.state.mensajitoEmpUser.apellido;
    }
    // this.$store.commit("load", "");
    // this.sesion = this.$store.state.mensajitoEmpUser;
  },
  computed: {
    login() {
      return this.$store.state.isUserLoggedIn;
    }
  },
  methods: {
    initialize() {},
    // mostrar(item) {
    //   if (this.$store.state.mensajitoEmpUser.permisos) {
    //     for (let i = 0; i < this.$store.state.mensajitoEmpUser.permisos.length; i++) {
    //       if (this.$store.state.mensajitoEmpUser.permisos[i].ruta === item) {
    //         return this.$store.state.mensajitoEmpUser.permisos[i].ruta;
    //       }
    //     }
    //   }
    // },
    showMenu(item) {
      if (this.$store.state.isUserLoggedIn && item.requiresAuth) {
        return true;
      } else if (!item.requiresAuth && !this.$store.state.isUserLoggedIn) {
        return true;
      }
      return false;
    },
    logout() {
      this.$store.dispatch("logout");
      this.$cookies.set("tokenSMS", [], "5D", "");
      window.location.href = "/";
    }
  }
};
</script>
<style lang="scss">
#app-drawer {
  .v-list__tile {
    border-radius: 4px;

    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
    }
  }

  .v-image__image--contain {
    top: 9px;
    height: 60%;
  }
  .fill-height {
    height: auto !important;
  }

  .search-input {
    margin-bottom: 30px !important;
    padding-left: 15px;
    padding-right: 15px;
  }

  .primary--text {
    color: white !important;
    caret-color: white !important;
  }
  .txt {
    height: 48px !important;
    font-size: 14px !important;
    font-weight: 300;
    padding: 9px;
    margin-left: -3px;
  }
  .brd {
    border-radius: 5px;
  }
  .v-list__group__header {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    cursor: pointer;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    list-style-type: none;
    border-radius: 5px;
  }
  .mtd {
    margin-left: 12px;
    margin-right: 6px;
  }
  .mgl {
    margin-left: -4px;
  }
}
.v-navigation-drawer
  .v-list
  .v-list-item {
    color: white;
  }
  .v-list__tile.v-list__tile--active.secundary {
  background-color: #a2a4a6 !important;
  color: white;
  -webkit-box-shadow: 0 12px 20px -10px rgba(97, 159, 122, 0.28),
    0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(97, 159, 122, 0.2) !important;
  box-shadow: 0 12px 20px -10px rgba(97, 159, 122, 0.28),
    0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(97, 159, 122, 0.2) !important;
}
#app-drawer .v-list__tile {
    border-radius: 4px;
    color: white;
}
</style>
